// extracted by mini-css-extract-plugin
module.exports = {"views":"ShopsView_views__pgE2L","isStatic":"ShopsView_isStatic__fAbk_","buttons":"ShopsView_buttons__d_Zk2","tabs":"ShopsView_tabs__PDKeA","load":"ShopsView_load___Xzso"};